import React from 'react';
import ContactInfo from './ContactInfo';
import FooterBrand from './FooterBrand';
import FooterLinks from './FooterLinks';
import SocialMedia from './SocialMedia';

/**
 * Desktop Footer Component
 * Displays footer content optimized for desktop screens
 * 
 * @param {Object} data - Footer data object
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {Boolean} isMenuVisible - Whether footer links should be visible
 * @param {String} className - Additional CSS classes
 */
const DesktopFooter = ({ data, isDarkMode, isMenuVisible = true, className = '' }) => {
    if (!data) return null;

    return (
        <footer className={`d-none d-md-block ${className}`} style={{
            backgroundColor: isDarkMode ? '#1a1a1a' : '#16110d',
            transition: 'background-color 0.3s ease',
            borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`
        }}>
            <div className={`tw-container ${isMenuVisible ? 'py-5' : 'py-4'}`}>
                {isMenuVisible ? (
                    <div className="row g-4">
                        {/* Company Info Section */}
                        <div className="col-lg-4 col-md-6">
                            <FooterBrand 
                                footerIcon={data.footerIcon}
                                description={data.FooterDescription}
                                isDarkMode={isDarkMode}
                            />
                            
                            <ContactInfo 
                                addresses={data.Address}
                                isDarkMode={isDarkMode}
                            />
                        </div>

                        {/* Services Links */}
                        {data.LeftBottomLinks && data.LeftBottomLinks.filter(link => !link.isHidden).length > 0 && (
                            <div className="col-lg-2 col-md-6">
                                <FooterLinks links={data.LeftBottomLinks} />
                            </div>
                        )}

                        {/* Legal Links */}
                        {data.rightBottomLinks && data.rightBottomLinks.filter(link => !link.isHidden).length > 0 && (
                            <div className="col-lg-2 col-md-6">
                                <FooterLinks links={data.rightBottomLinks} />
                            </div>
                        )}

                        {/* Social Media Section */}
                        {data.socialIcons && data.socialIcons.length > 0 && (
                            <div className="col-lg-4 col-md-6">
                                <SocialMedia 
                                    socialIcons={data.socialIcons}
                                    isDarkMode={isDarkMode}
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-7 col-md-6">
                            <FooterBrand 
                                footerIcon={data.footerIcon}
                                description={data.FooterDescription}
                                isDarkMode={isDarkMode}
                                fullWidth
                            />
                        </div>
                        <div className="col-lg-5 col-md-6">
                            <ContactInfo 
                                addresses={data.Address}
                                isDarkMode={isDarkMode}
                            />
                        </div>
                    </div>
                )}
                
                {/* Footer Bottom */}
                <div style={{
                    borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`,
                    marginTop: isMenuVisible ? '0.5rem' : '0.25rem',
                    paddingTop: isMenuVisible ? '2rem' : '1.25rem'
                }}>
                    <div className="d-flex justify-content-center">
                        <p style={{
                            color: '#888',
                            fontSize: '14px',
                            margin: '0',
                            textAlign: 'center'
                        }}>
                            {data.Copyrights || `© ${new Date().getFullYear()} HireGo. All Rights Reserved.`}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default DesktopFooter;
